const path = 'redux/marketing';
export const MARKETINGS_LOADED = `${path}/MARKETINGS_LOADED`;
export const MARKETING_LOADED = `${path}/MARKETING_LOADED`;
